import { render, staticRenderFns } from "./searchArticle.vue?vue&type=template&id=0701d8f0"
import script from "./searchArticle.vue?vue&type=script&lang=js"
export * from "./searchArticle.vue?vue&type=script&lang=js"
import style0 from "./searchArticle.vue?vue&type=style&index=0&id=0701d8f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports